import { split } from "lodash";

// Separator between Repo and Version List
const REPO_VERSION_SEPARATOR = "||";

export const parseRepoVersionString = (str = "") => {
  const map = {};
  if (str === "all") {
    map["all"] = [];
    return map;
  }
  // Split by comma to get "repo||v1;v2" segments
  split(str, ",").forEach((segment) => {
    if (segment.includes(REPO_VERSION_SEPARATOR)) {
      const [repo, versionsPart] = segment.split(REPO_VERSION_SEPARATOR);
      const versions = versionsPart.split(";").filter((v) => v);
      map[repo] = versions;
    }
  });
  return map;
};

export const parseVersionSelectOptions = (options) =>
  (options || []).map((v) => ({
    label: `${v.tag.split(":|")[0]} (${v.imageId})`,
    imageId: v.imageId, // <-- Store the imageId
    value: v.tag,
  }));

export const buildRepoVersionString = (repoMap = {}) => {
  return Object.entries(repoMap)
    .map(
      ([repo, versions]) =>
        `${repo}${REPO_VERSION_SEPARATOR}${[...new Set(versions)].join(";")}`,
    )
    .join(",");
};

// Helper to flatten all versions from a map into a single comma-separated string
export const buildFlattenedVersions = (repoMap = {}) => {
  return Object.values(repoMap).flat().join(",");
};

//build map from names ref
export const getNamesFromMap = (ids = [], map = {}) => {
  return ids.map((id) => map[id] || id).join(",");
};

export const IMAGE_VALUE = "images";

export const HOST_VALUE = "host";

export const APPLICATION_SECURITY_VALUE = "applicationSecurity";

export const API_SECURITY_VALUE = "apiSecurity";

export const PRISMA_CLOUD_COMPUTE_RADIO_OPTIONS = [
  {
    label: "Images",
    value: IMAGE_VALUE,
  },
  {
    label: "Host",
    value: HOST_VALUE,
  },
  {
    label: "Application Security",
    value: APPLICATION_SECURITY_VALUE,
  },
  {
    label: "API Security",
    value: API_SECURITY_VALUE,
  },
];

export const IMAGE_TYPE_OPTIONS = [
  {
    label: "Deployed",
    value: "deployed",
  },
  {
    label: "Registry",
    value: "registry",
  },
  {
    label: "CI",
    value: "ci",
  },
];

export const parseAndCleanVersions = (str) => {
  if (!str || str === "all") return [];
  return str
    .split(",")
    .map((segment) => {
      let repo, versionsPart;

      // Handle new separator (Registry/CI)
      if (segment.includes("||")) {
        [repo, versionsPart] = segment.split("||");
      }
      // Handle old/deployed separator
      else if (segment.includes("|:")) {
        [repo, versionsPart] = segment.split("|:");
      } else {
        return null;
      }

      if (!repo) return null;

      // Clean version strings: "0.1:|sha256:123" -> "0.1"
      const cleanVersions = (versionsPart || "")
        .split(";")
        .filter(Boolean)
        .map((v) => {
          // Split on first occurence of :| to separate tag from ID
          const parts = v.split(":|");
          return parts[0];
        })
        .join(", ");

      return { repo, versions: cleanVersions || "All" };
    })
    .filter(Boolean);
};
